import { Input } from "antd";
import Commonformerror from "./CommonFormError";
import Commonformlabel from "./CommonFormLabel";

interface props {
  name: string;
  value?: any;
  onChange?: (value: any) => void;
  required?: boolean;
  error?: any;
  touched?: any;
  labelname?: string;
  onPaste?: any;
  maxLength?: any;
  onKeyDown?: any;
  isInvalid?: any;
  readonly?: boolean;
}

function CommonInputTwo({
  value,
  required = false,
  name,
  onChange,
  error,
  labelname,
  touched,
  onPaste,
  maxLength,
  onKeyDown,
  readonly = false,
}: props) {
  return (
    <>
      <Commonformlabel labelname={labelname} required={required} />

      <Input
        name={name}
        value={value}
        onChange={onChange}
        onPaste={onPaste}
        maxLength={maxLength}
        onKeyDown={onKeyDown}
        readOnly={readonly}
        size="large"
        placeholder={labelname}
      />

      <Commonformerror
        required={required}
        touched={touched}
        name={name}
        error={error}
      />
    </>
  );
}

export default CommonInputTwo;
